import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import {
  Platform,
  TranslationsService,
} from '../../services/translations/translations.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  public error?: HttpErrorResponse;

  public isReady = false;

  private isMobile = false;

  constructor(private readonly translationsService: TranslationsService) {}

  ngOnInit(): void {
    this.translationsService.ready
      .pipe(filter((ready) => ready))
      .subscribe(() => {
        if (this.translationsService.hasError()) {
          this.error = this.translationsService.getError();
        } else {
          this.isReady = true;
        }
      });
    this.isMobile = this.translationsService.getPlatform() === Platform.mobile;
  }

  isDesktop(): boolean {
    return !this.isMobile;
  }

  hasError(): boolean {
    return this.error instanceof HttpErrorResponse;
  }

  getErrorMessage(): string {
    return this.error && this.error.error;
  }
}
